module.exports = __webpack_public_path__ + "img/ankle-before-roll.c5ca4da1.svg";